import React from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { pathHomePage, pathLogin, pathRegister, pathAgenda, pathTherapistHome, pathPatientProfile, pathPatientHome, pathPatientActivityPlan, pathTherapistActivityPlan } from "../config/constants";
import Login from "../views/Login";
import Register from "../views/Register";
import Agenda from "../views/Agenda";
import TherapistHome from "../views/TherapistHome";
import PatientProfile from "../views/PatientProfile";
import PatientHome from "../views/PatientHome";
import PatientActivityPlan from "../views/PatientActivityPlan";
import TherapistActivityPlan from "../views/TherapistActivityPlan";
import CallNotification from "../components/callNotification";

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={() =>
      localStorage.getItem("token") ? <Component /> : <Redirect to={pathLogin} />
    }
  />
);

const RootRedirect = () => {
  const token = localStorage.getItem("token");
  if (!token) return <Redirect to={pathLogin} />;
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  if (user.role === "patient")    return <Redirect to={pathPatientHome} />;
  if (user.role === "therapist")  return <Redirect to={pathTherapistHome} />;
  return <Redirect to={pathLogin} />;
};

const Routes = () => (
  <BrowserRouter>
    <CallNotification />
    <Switch>
      <Route path={pathLogin} component={Login} exact />
      <Route path={pathRegister} component={Register} exact />
      <PrivateRoute path={pathAgenda} component={Agenda} exact />
      <PrivateRoute path={pathTherapistActivityPlan} component={TherapistActivityPlan} exact />
      <PrivateRoute path={pathPatientActivityPlan} component={PatientActivityPlan} exact />
      <PrivateRoute path={pathPatientHome} component={PatientHome} exact />
      <PrivateRoute path={pathTherapistHome} component={TherapistHome} exact />
      <PrivateRoute path={pathPatientProfile} component={PatientProfile} exact />
      <Route path={pathHomePage} component={RootRedirect} exact />
      <Redirect to={pathLogin} />
    </Switch>
  </BrowserRouter>
);

export default Routes;
